/**
 * Spec Console の TanStack Query キーの束ね口。
 *
 * キーは procedure 名を第 2 要素に固定し、入力をそのまま後続の要素へ載せる。procedure と
 * キーの対応を 1 つの入口に集約するのは、キーの取り違えが「別データが混ざる」「無効化が
 * 効かない」というキャッシュの誤りとして表面化し、型では捕まらないためである。キーそのものは
 * 機能ごとのファイル（`query-keys/*`）が持ち、ここは並べるだけである。
 *
 * 本文を返す procedure のキーは末尾に表示言語（`locale`）を載せる。読取は 1 locale だけを
 * 返すので、言語を載せないと切り替えたときに前の言語の応答がキャッシュから返り、画面の一部
 * だけが元の言語のまま残る。言語は契約側でも入力なので、他の入力と同じく後続要素に置く。
 * 本文を返さない案件の読取だけが例外で、理由はその定義に書いてある。
 *
 * 案件を受ける読取のキーは、言語の 1 つ手前に案件番号を載せる（`pjNumber ?? null`）。
 * 同じ procedure を「現在版」と「案件を適用した後」で 2 回引くので、載せないと後から引いた
 * 側が相手を上書きし、案件を外した瞬間に案件の姿が残る。並びは一覧と detail で揃える。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business 機能ごとの Query キーを 1 つの入口から引けるように並べる。
 * @graph-connects none
 */
import { businessLogicQueryKeys } from './query-keys/business-logic.js';
import { businessMapQueryKeys } from './query-keys/business-map.js';
import { authQueryKeys, specGraphCommonQueryKeys } from './query-keys/common.js';
import { flowQueryKeys } from './query-keys/flow.js';
import { mastersQueryKeys } from './query-keys/masters.js';
import { pjSpecGraphQueryKeys, pjSpecPjQueryKeys } from './query-keys/pj.js';

/** Web が引く仕様グラフ読取 procedure と auth の Query キー。 @graph-connects none */
export const queryKeys = {
  auth: authQueryKeys,
  specGraph: {
    ...specGraphCommonQueryKeys,
    ...businessMapQueryKeys,
    ...flowQueryKeys,
    ...businessLogicQueryKeys,
    ...pjSpecGraphQueryKeys,
    ...mastersQueryKeys,
  },
  specPj: {
    ...pjSpecPjQueryKeys,
  },
} as const;
